'use client';

import { cx } from 'class-variance-authority';
import { Icon } from '~/components/primitives';
import Title from '~/components/utils/Title';
import { usePortalCtx } from '~/features/global/portal';

const CheckoutInfoCard: React.FC<{
    title: string;
    description?: string;
    checklist?: Array<React.ReactNode>;
    className?: string;
    children?: React.ReactNode;
}> = props => {
    const portal = usePortalCtx();

    return (
        <div
            className={cx(
                'rounded-2xl p-10',
                portal.portal === 'BIZZ' ? 'bg-(--biz-bg)' : 'bg-brown-50',
                props.className,
            )}
        >
            <Title as="h3" size="xl" weight="xbold" className="mb-6">
                {props.title}
            </Title>
            {props.description && (
                <p
                    className={cx(
                        'text-sm',
                        portal.portal === 'BIZZ' ? 'text-primary' : 'text-blue-700',
                    )}
                >
                    {props.description}
                </p>
            )}
            {!!props.checklist?.length && (
                <ul className="mt-6 space-y-4 text-sm font-normal leading-6 text-primary">
                    {props.checklist.map((x, i) => (
                        <li className="inline-flex" key={i}>
                            <Icon name="check" className="mr-2.5 shrink-0 text-turqoise-500" />
                            <span>{x}</span>
                        </li>
                    ))}
                </ul>
            )}
            {props.children}
        </div>
    );
};

export default CheckoutInfoCard;
